/**
 * Formats d'affichage de date, au choix de chaque utilisateur (préférences).
 * Le stockage et les échanges avec l'API restent toujours en ISO `YYYY-MM-DD`
 * (cf. `isoDateSchema`) : seul l'affichage change, jamais la valeur portée.
 */
export const DATE_FORMATS = ['YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY', 'MM/DD/YYYY'];
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
/** Reformate une date ISO `YYYY-MM-DD` selon la préférence ; passe tout le reste inchangé. */
export function formatDate(value, format = DEFAULT_DATE_FORMAT) {
    if (!value)
        return '';
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    if (!match)
        return value;
    const [, year, month, day] = match;
    switch (format) {
        case 'DD/MM/YYYY':
            return `${day}/${month}/${year}`;
        case 'DD-MM-YYYY':
            return `${day}-${month}-${year}`;
        case 'MM/DD/YYYY':
            return `${month}/${day}/${year}`;
        default:
            return `${year}-${month}-${day}`;
    }
}
/**
 * Ordre chronologique des lignes de facture (détail, PDF) : date ISO puis
 * heure `HH:MM`. Une ligne sans date passe toujours après celles qui en ont
 * une — jamais avant, ce qui la ferait paraître antérieure à tout le reste.
 * Comparateur stable : à date/heure égales (ou toutes deux absentes), l'ordre
 * d'origine du tableau est conservé.
 */
export function compareDateTime(a, b) {
    const key = (entry) => (entry.date ? `${entry.date} ${entry.time ?? '00:00'}` : '9999-99-99 99:99');
    return key(a).localeCompare(key(b));
}
/**
 * Date locale `YYYY-MM-DD`. Surtout pas `toISOString().slice(0, 10)` : il
 * convertit en UTC, et à Paris (UTC+1/+2) minuit local devient la veille —
 * un mois de septembre calculé ainsi s'arrêtait au 29 et perdait les factures
 * du 30.
 */
export function localIsoDate(date = new Date()) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
}
/** Mois civil local : `start` inclus, `end` exclu (premier jour du mois suivant). */
export function monthRange(monthsAgo = 0, reference = new Date()) {
    const start = new Date(reference.getFullYear(), reference.getMonth() - monthsAgo, 1);
    const end = new Date(reference.getFullYear(), reference.getMonth() - monthsAgo + 1, 1);
    return { start: localIsoDate(start), end: localIsoDate(end) };
}
//# sourceMappingURL=date.js.map